import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public static readonly configPath = 'config/config.json';

  public config: Record<string, unknown>;

  constructor(private http: HttpClient) {
    this.config = {};
  }

  public getConfig(): object {
    return this.config;
  }

  public load(): Promise<boolean> {
    // Skip on server-side rendering
    if (typeof window === 'undefined') {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      const cached = sessionStorage.getItem(AppConfigService.configPath);
      if (cached) {
        try {
          this.config = JSON.parse(cached) as Record<string, unknown>;
          resolve(true);
          return;
        } catch {
          // corrupted cache — fall through to fetch
        }
      }

      this.http
        .get(AppConfigService.configPath)
        .pipe(
          take(1),
          catchError((err) => throwError(() => err || new Error('Server error')))
        )
        .subscribe({
          next: (configResponse: object) => {
            sessionStorage.setItem(
              AppConfigService.configPath,
              JSON.stringify(configResponse)
            );
            this.config = configResponse as Record<string, unknown>;
            resolve(true);
          },
          error: (err) => {
            console.error('Failed to load app config:', err);
            resolve(true);
          },
        });
    });
  }
}
